import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { CoreConfigService } from '../config/core-config.service';

@Injectable({ providedIn: 'root' })
export class AccountService {
    constructor(
        private http: HttpClient,
        private configService: CoreConfigService,
    ) { }

    get(): Observable<any> {
        return this.http.get(this.configService.apiUrls.account);
    }

    save(account: any): Observable<any> {
        return this.http.post(this.configService.apiUrls.account, account);
    }
}
